import React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';

import resetDeviceDetails from '../../actions/reset-device-details';
import DeviceIcon from '../device';
import Button from '../button';
import { format as formatPhoneNumber } from '../../utils/phone-number';
import { CUSTOMER_DETAILS } from '../../steps';

export default function({ onConfirm = () => {}, ineligible = false }) {
  const dispatch = Redux.useDispatch();
  const {
    pageText: { noButton, yesButton, customerDetails },
    selectedDevices: {
      brand = '',
      model: { name = '', carrier = '', capacity = '' },
    },
    contact: { phoneNumber },
  } = Redux.useSelector(state => state);

  const details = {
    deviceName: `${brand} ${name}`,
    carrierCapacity: [carrier, capacity].filter(Boolean).join(', '),
    phoneNumber: formatPhoneNumber(phoneNumber),
  };

  return (
    <>
      <DetailItem>
        <ul className="list">
          <li>
            <DeviceIcon />
            {details.deviceName}
          </li>
          <li>{details.carrierCapacity}</li>
        </ul>
      </DetailItem>

      {!ineligible ? (
        <ConfirmDetailsContainer>
          <div className="confirmation-text">
            {customerDetails.confirmDetails}
          </div>
          <ButtonsContainer>
            <Button
              className="confirm outlined"
              disabled={false}
              name="No (details-fetched)"
              onClick={() => {
                dispatch(resetDeviceDetails());
                onConfirm();
              }}
              step={CUSTOMER_DETAILS}
            >
              {noButton}
            </Button>
            <Button
              className="confirm"
              disabled={false}
              name="Yes (details-fetched)"
              onClick={() => onConfirm()}
              step={CUSTOMER_DETAILS}
            >
              {yesButton}
            </Button>
          </ButtonsContainer>
        </ConfirmDetailsContainer>
      ) : null}
    </>
  );
}

const DetailItem = styled.div`
  display: flex;
  justify-content: center;

  .list {
    color: ${props => props.theme.subText};
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
    li:nth-child(2) {
      padding-bottom: 15px;
    }

    li {
      position: relative;
      padding-bottom: 5px;
      font-weight: 300;
      font-size: 24px;

      svg {
        position: absolute;
        top: 0;
        left: -20%;
      }
    }
  }
`;
const ButtonsContainer = styled.div`
  display: flex;
  gap: 25px;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 35px;

  .cancel {
    padding: 10px 0px;
    background: none;
    border: 1px solid #00aeef;
    .button-text {
      color: #00aeef;
    }
  }
  .confirm {
    color: #fff;
    border: 1px solid #00aeef;
    padding: 10px 0px;
    width: 50%;
  }
  .button-text {
    font-weight: 500;
    font-size: 1em;
  }
`;

const ConfirmDetailsContainer = styled.div`
  border: 2px solid #00aeef;
  border-radius: 10px;
  padding: 1em;
  margin-top: 2em;
  display: flex;
  flex-direction: column;

  .confirmation-text {
    color: #00aeef;
    font-size: 1.4em;
  }
`;
